// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__E-07e","icon":"styles_icon__oBhrL"};